import '../styles/global.scss';

import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import SiteHeader from "../components/layout/SiteHeader";
import { initLenis, initParallax } from '../components/lib/scroll'

function App({ Component, pageProps }) {

	const router = useRouter();
	const frameCountRef = useRef(0);

	useEffect(() => {
		if (typeof window === 'undefined') return
		const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
		document.body.classList.add(isTouch ? 'state-touch' : 'state-no-touch')
		const hasMouse = window.matchMedia('(pointer: fine)').matches && window.matchMedia('(hover: hover)').matches

		const lenis = hasMouse ? initLenis() : null
		if (lenis) {
			window.lenis = lenis;
		}
		
		const handleRouteStart = () => {
			document.body.classList.remove('state-page-loaded');
			document.body.classList.add('state-page-not-loaded')
			frameCountRef.current = 0 // Reset frame counter for consistent throttling
			
			// Scroll to top with Lenis smooth scrolling
			if (lenis) {
				lenis.scrollTo(0, { duration: 0.5 })
			}
		}
		const handleRouteComplete = () => {
			document.body.classList.remove('state-page-not-loaded');
			document.body.classList.add('state-page-loaded');
			// Re-initialize parallax elements after page load
			setTimeout(() => {
				initParallax();
			}, 100);
		}
		
		router.events.on('routeChangeStart', handleRouteStart)
		router.events.on('routeChangeComplete', handleRouteComplete)
			// Initialize parallax on initial page load
			initParallax();
		router.events.on('routeChangeError', handleRouteComplete)
		
		setTimeout(() => {
			document.body.classList.add('state-site-loaded', 'state-page-loaded')
		}, 200)

		return () => {
			router.events.off('routeChangeStart', handleRouteStart)
			router.events.off('routeChangeComplete', handleRouteComplete)
			router.events.off('routeChangeError', handleRouteComplete)
		}
	}, [router.events])

	return (
		<>
			<Script
				id="marker-config"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						window.markerConfig = {
							project: '698c2b6392e0c844353594d7', 
							source: 'snippet'
						};
					`
				}}
			/>
			<Script
				id="marker-loader"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						!function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","clearReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);
					`
				}}
			/>
			<SiteHeader global={pageProps.global} />
			<Component key={router.asPath} {...pageProps} />
		</>
	);
}

export default App;
